import React from "react";
import SignInComponent from "../components/SignIn/index";

const SignIn = () => {
  return <SignInComponent />;
};

export default SignIn;
